module.exports = __webpack_public_path__ + "static/img/jkzs-title.e36c42a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/jkzs-title.png
// module id = S3Ef
// module chunks = 1